import { TylerMatTableDataSource } from './../../../shared-components/angular-material/extended.class';
import {
    AfterViewInit,
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges, OnInit,
    ViewChild
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'assessment-data-table',
    templateUrl: './assessment-data-table.component.html',
    styleUrls: [
        './assessment-data-table.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssessmentDataTableComponent implements OnInit, AfterViewInit, OnChanges {

    // Properties
    private _sort: MatSort;
    @Input() data: TylerMatTableDataSource;
    @Input() fields: string[];
    @Input() minTableWidth: number;
    @Input() showFilters = true;
    @Input() triggerChanges: EventEmitter<any>;
    triggerChangeSubscription: Subscription;
    fieldsColumns: string[] = [];

    // Class Functions
    constructor(
        private changeDetector: ChangeDetectorRef,
        private router: Router
    ) { }

    get sort(): MatSort {
        return this._sort;
    }

    @ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
        this._sort = value;
        if (this.data) {
            this.data.sort = this._sort;
            this.setSorting();
        }
    }

    // Event Functions
    ngOnInit() {
        // POST: subscribes to manual changes
        if (this.triggerChanges) {
            this.triggerChangeSubscription = this.triggerChanges.subscribe(() => {
                this.changeDetector.markForCheck();
            });
        }
        if (this.router.url.toLowerCase().indexOf('registrationenrollment') > -1 && this.fields.indexOf('action') == -1) {
            this.fields.push('actions');
        }
        this.fields.forEach(f => {
            this.fieldsColumns.push(f);
        });
    }

    ngAfterViewInit() {
        // POST: sets the table data's sort
        this.setSorting();
    }

    ngOnChanges() {
        // POST: unsubscribes to manual changes and sets the table data's sort
        if (this.triggerChangeSubscription) {
            this.triggerChangeSubscription.unsubscribe();
        }
        this.setSorting();
    }

    // Methods
    setSorting() {
        // PRE: table data
        // POST: sets the table data's sort
        if (this.data && this.sort) {
            this.data.sort = this.sort;
            this.data.sortingDataAccessor = (data: any, sortHeaderId: string): string | number => {
                let value = data[sortHeaderId];
                const dateRegex = /\d{2}\/\d{2}\/\d{2}/y;
                if (value) {
                    if (dateRegex.test(value)) {
                        value = new Date(value);
                        return value.getTime();
                    } else {
                        return this.data.defaultSortingAccessor(data, sortHeaderId);
                    }
                } else {
                    return '';
                }
            };
            this.sort.sort({
                id: this.fields[0],
                start: 'asc',
                disableClear: true
            });
        }
    }

    fieldTrackBy(index: number, item: string) {
        return item + index;
    }
}
